// Max amount of characters alloted for candidate 'About'
export const ABOUT_CANDIDATE_MAX = 300;

// Max amount of characters alloted for each candidate accomplishment.
export const ACCOMPLISHMENT_CANDIDATE_MAX = 300;
